import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { Label } from '@/components/ui/label'

interface FormFieldProps {
    id: string
    label: string
    children: ReactNode
    error?: string
    hint?: ReactNode
    required?: boolean
    className?: string
}

// Label, control and one line of help or error text. Controls should set
// aria-describedby to fieldMessageId(id) and aria-invalid when there is an error.
export const FormField: FC<FormFieldProps> = ({ id, label, children, error, hint, required = false, className }): ReactNode => {
    return (
        <div className={cn('space-y-1.5', className)}>
            <Label htmlFor={id}>
                {label}
                {required && <span className='text-destructive' aria-hidden='true'>*</span>}
            </Label>

            {children}

            {error
                ? (
                    <p id={fieldMessageId(id)} className='text-xs font-medium text-destructive' role='alert'>
                        {error}
                    </p>
                )
                : hint && (
                    <p id={fieldMessageId(id)} className='text-xs text-muted-foreground'>
                        {hint}
                    </p>
                )}
        </div>
    )
}

export const fieldMessageId = (id: string): string => `${id}-message`

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/
